<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <h4 class="mb-3 text-center">Select Printer</h4>

          <div class="row g-2">
            <label v-for="p in printers" :key="p.id" class="col-6">
              <div
                class="
                  border
                  rounded
                  p-3
                  h-100
                  d-flex
                  flex-column
                  align-items-start
                  printer-card
                "
                :class="{ 'border-primary': selected === p.id }"
              >
                <input
                  type="radio"
                  class="form-check-input mb-2"
                  :value="p.id"
                  v-model="selected"
                />
                <strong>{{ p.name }}</strong>
                <small class="text-muted">Size: {{ p.size }}</small>
              </div>
            </label>
          </div>

          <div class="d-flex gap-2 justify-content-center mt-4">
            <button
              class="btn btn-primary"
              @click="confirm(false)"
              :disabled="!selected"
            >
              Print
            </button>
            <button
              class="btn btn-success"
              @click="confirm(true)"
              :disabled="!selected"
            >
              Always use
            </button>
            <button class="btn btn-secondary" @click="cancel">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");

export default {
  props: ["show", "printers", "method"],
  data() {
    return {
      selected: "",
      myModal: null,
    };
  },
  mounted() {
    this.myModal = new bootstrap.Modal(this.$refs.modal, {
      backdrop: "static",
    });
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.myModal.show();
      } else {
        this.myModal.hide();
      }
    },
  },
  methods: {
    confirm(always) {
      if (!this.selected) return;
      this.$emit("choose", { printerId: this.selected, always });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
